import { CardHeader, Divider, CardContent, Typography, Stack, Box } from '@mui/material';

import { fDateTime } from '../../utils/formatTime';
import type { RequestProps } from '../../models';

const style = {
	divider: { borderBottomWidth: 1.5 },
};

interface PrefAssessmentDatesProps {
	prefAssessmentDates: RequestProps['prefAssessmentDates'];
}

export const PrefAssessmentDates: React.FC<PrefAssessmentDatesProps> = ({ prefAssessmentDates }) => {
	if (!prefAssessmentDates || prefAssessmentDates.length === 0) return null;

	const labels = ['Primary', 'Secondary', 'Third'] as const;
	const dates = prefAssessmentDates.slice(0, 3);

	if (dates.every((d) => !d)) return null;

	return (
		<>
			<CardHeader title="Preferred Assessment Dates" />
			<Divider sx={style.divider} />
			<CardContent>
				<Stack spacing={2}>
					{dates.map((date, idx) => {
						if (!date) return null;
						return (
							// biome-ignore lint/suspicious/noArrayIndexKey: items length will not change
							<Stack key={idx} direction="row" spacing={2} alignItems="center">
								<Box>
									<Typography variant="subtitle1" sx={{ lineHeight: 1 }}>
										{labels[idx]}
									</Typography>
									<Typography variant="body1">{fDateTime(date)}</Typography>
								</Box>
							</Stack>
						);
					})}
				</Stack>
			</CardContent>
		</>
	);
};
